import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceAgreementHttpService } from './service-agreements.service';
import { IServiceAgreement } from './service-agreements.interface';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AlertService } from '../../../shared/services/alert.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ITask } from '../../tasks-page/tasks/task.interface';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { BillingDocumentsModalComponent } from '../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { IBillingDocumentTypes } from '../../billing-documents-page/billing-documents/billing-documents.interface';

let self: any;

@Component({
  selector: 'app-service-agreements',
  templateUrl: './service-agreements.component.html',
  styleUrls: ['./service-agreements.component.css']
})
export class AgreementsComponent implements OnInit {
  loading: boolean = false;
  thereAreMore: boolean = false;
  // selectedDayStart: string = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString()).substring(0, 10);
  // selectedDayEnd: string = this._UtilsService.date.toLocale(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()).substring(0, 10);
  filter: IFilter = {
    filters: {
      taskStartDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substring(0, 10),
      taskEndDate: new Date().toISOString().substring(0, 10),
      isDeleted: false,
    },
    sort: '',
    skip: 0,
    limit: 20,
  };
  filtered = false;
  scrollSubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  agreements: any;
  agreementsInvoicing: boolean = false;
  curr!: string;
  querySubscription!: Subscription;

  constructor(
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
    private _dialogService: DialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _AlertService: AlertService,
    private _UtilsService: UtilsService,
    private _broadcaster: Broadcaster,
    private _AuthService: AuthService,
    public _ServiceAgreementHttpService: ServiceAgreementHttpService,

  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  ngOnInit() {
    if (!this.agreementsInvoicing) {
      delete this.filter.filters.taskStartDate;
      delete this.filter.filters.taskEndDate;
    }
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();

    // this.getQuotes(true);
    this.getAgreements(true)
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getAgreements(true);
      }
    }, 1000);
  }

  getAgreements(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.agreements = [];
    }

    console.log(this.filter)
    const filter = _.cloneDeep(this.filter);
    if (filter.filters.dateStart)
      filter.filters.dateStart = this._UtilsService.date.toUTC(filter.filters.dateStart + 'T00:00:00.000Z');
    if (filter.filters.dateEnd)
      filter.filters.dateEnd = this._UtilsService.date.toUTC(filter.filters.dateEnd + 'T23:59:59.999Z');

    this._ServiceAgreementHttpService.getAgreements(filter).subscribe(async (agreements) => {
      console.log(agreements);
      this.agreements = _.concat(this.agreements, agreements);
      this.thereAreMore = agreements.length >= self.filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      self.filter.skip += self.filter.limit;
      this.getAgreements();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      this.agreementsInvoicing = false;

      if (params['action'] == 'INVOICE') {
        this.filter.limit = 10000;
        if (!this.agreementsInvoicing) this.agreementsInvoicing = true;
        else this.getAgreements(true);
      }
    })
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getAgreements(true);
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.agreements.every((agreement: any) => {
        const id = agreement?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.agreements.forEach((agreement: any) => {
        const id = agreement?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }

  openCreateAgreementsInvoice() {
    const ids = Object.keys(this.selection).filter(el => el != 'all' && el != 'some' && this.selection[el]);
    let agreements = this.selection.all ? this.agreements : this.agreements.filter((agreements: any) => ids.find(id => id == agreements._id));
    return this.openCreateInvoice(agreements, this.filter.filters.taskStartDate, this.filter.filters.taskEndDate);
  }

  openCreateAgreementInvoice(agreement: IServiceAgreement) {
    const tasks: any = agreement.tasks?.sort((task1, task2) => {
      return new Date(task1.scheduledStart || '').getTime() < new Date(task1.scheduledStart || '').getTime() ? 1 : 0
    })
    this.openCreateInvoice([agreement], tasks[0]?.scheduledStart, tasks[tasks.length - 1]?.scheduledStart);
  }

  openCreateInvoice(agreements: IServiceAgreement[], startDate: Date, endDate: Date) {

    // validate same client
    if (agreements.filter((task: any) => task.client._id != agreements[0].client?._id).length > 0)
      return this._AlertService.warn("Los Tabajos seleccionados deben corresponder al mismo Cliente");

    const modalOptions: IConfirmationDialogOptions = {
      title: "Generar Factura",
      message: "Está seguro que desea Facturar el/los Contrato(s) seleccionado(s)?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {

          let config = new MatDialogConfig();
          config.width = '1200px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
          self.dialogRef.componentInstance.agreementsTaskDates = {
            start: new Date(startDate),
            end: new Date(endDate),
          };
          self.dialogRef.componentInstance.agreements = agreements;
          self.dialogRef.componentInstance.document = {
            type: IBillingDocumentTypes.INVOICE,
            client: agreements[0].client,
          };
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.editting = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            // self.dialogRef = null;
            this._router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents']).then(() => {
              // window.location.reload();
            });
          });
        }
      });
  }
}